import type React from 'react';

import classNames from 'classnames';

import logo from '@/images/logo.svg';
import { customAppIcon, title } from '@/mastodon/initial_state';

export const WordmarkLogo: React.FC = () => (
  <svg viewBox='0 0 261 66' className='logo logo--wordmark' role='img'>
    <title>Mastodon</title>
    <use xlinkHref='#logo-symbol-wordmark' />
  </svg>
);

export const IconLogo: React.FC<React.ComponentPropsWithRef<'svg'>> = ({
  className,
  role = 'img',
  ...otherProps
}) => (
  <svg
    viewBox='0 0 79 79'
    className={classNames('logo logo--icon', className)}
    role={role}
    {...otherProps}
  >
    {role !== 'presentation' && <title>Mastodon</title>}
    <use xlinkHref='#logo-symbol-icon' />
  </svg>
);

/**
 * The small logo of the Home and Explore headers. It is the app icon the
 * admin uploaded (Administration > Server settings > Branding), like the
 * logo of the settings pages, or Mastodon's when there is none.
 */
export const SymbolLogo: React.FC = () =>
  customAppIcon ? (
    <img
      src={customAppIcon}
      alt={title}
      className='logo logo--icon logo--app-icon'
    />
  ) : (
    <img src={logo} alt='Mastodon' className='logo logo--icon' />
  );
